export const getNotificationMessage = (error, type) => {
  if (!error || !Object.keys(error).length) return `Error in ${type}`;

  if (typeof error === 'string') return error;

  return `${Object.keys(error)[0].replace(/_/ug, ' ')} ${typeof error[Object.keys(error)[0]] === 'string'
    ? error[Object.keys(error)[0]] : error[Object.keys(error)[0]][0]}`;
};
